export default {
  WROComplete: 1,
  UROOnHold: 2,
  PaymentFailed: 3
}
